<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from '../../axios';

import SidenavItem from "./SidenavItem.vue";
// import SidenavCard from "./SidenavCard.vue";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const router = useRouter();
const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};

const logout = () => {
  axios.post("api/logout").then(() => {
    localStorage.removeItem("authenticatedUserId");
    localStorage.removeItem("sanctumToken");
    localStorage.removeItem("email");
    store.commit("auth/setUser", null);
    store.commit("auth/setTotalQuotes", 0);
    store.commit("auth/setPendingQuotes", 0);
    router.push({ path: "/signin" });
  });
}

</script>
<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item to="/dashboard" :class="getRoute() === 'dashboard' ? 'active' : ''"
          :navText="isRTL ? 'لوحة القيادة' : 'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item to="/quote-management" :class="['quote-management', 'single-quotation'].includes(getRoute()) ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Quote Management'">
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      
        <li class="nav-item">
        <sidenav-item to="/test-quote-management" :class="['test-quote-management', 'test-single-quotation'].includes(getRoute()) ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Test Quote Management'">
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <!-- <li class="nav-item">
        <sidenav-item
          to="/billing"
          :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Email Integration'"
        >
          <template v-slot:icon>
            <i class="ni ni-email-83 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/billing"
          :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Box Configuration'"
        >
          <template v-slot:icon>
            <i class="ni ni-box-2 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
      <li class="nav-item">
        <sidenav-item to="/setting" :class="getRoute() === 'Setting' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Setting'">
          <template v-slot:icon>
            <i class="ni ni-settings-gear-65 text-dark text-sm opacity-10"></i>
            <!-- <i class="bi bi-gear"></i> -->
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item to="/configuration" :class="getRoute() === 'Configuration' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Configuration'">
          <template v-slot:icon>
            <i class="fa fa-cogs text-dark text-sm opacity-10"></i>
          </template>

        </sidenav-item>

      </li>
      <li class="nav-item">
        <sidenav-item to="/test-configuration" :class="getRoute() === 'TestConfiguration' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Test Configuration'">
          <template v-slot:icon>
            <i class="fa fa-cogs text-dark text-sm opacity-10"></i>
          </template>

        </sidenav-item>

      </li>

      <li class="nav-item">
        <sidenav-item to="/products" :class="getRoute() === 'Products' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Products'">
          <template v-slot:icon>
            <i class="fa fa-box text-dark text-sm opacity-10"></i> 
          </template>

        </sidenav-item>

      </li>

      <li class="nav-item">
        <sidenav-item to="/notifications" :class="getRoute() === 'Notification' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Notification'">
          <template v-slot:icon>
            <i class="fa fa-bell text-dark text-sm opacity-10"></i>
            <span class="notification-count" >{{ store.state.auth.unreadCounts }}</span>
          </template>

        </sidenav-item>

      </li>
      <li class="nav-item ctm_logout">
        <sidenav-item to="/signin" @click="logout" :class="getRoute() === 'Logout' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Logout'">
          <template v-slot:icon>
            <i class="ni ni-button-power text-dark text-sm opacity-10"></i>

          </template>
        </sidenav-item>
      </li>

      <!-- <li class="nav-item">
        <sidenav-item
          to="/virtual-reality"
          :class="getRoute() === 'virtual-reality' ? 'active' : ''"
          :navText="isRTL ? 'الواقع الافتراضي' : 'Virtual Reality'"
        >
          <template v-slot:icon>
            <i class="ni ni-app text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      

      <li class="mt-3 nav-item">
        <h6
          v-if="isRTL"
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          صفحات المرافق
        </h6>

        <h6
          v-else
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'"
        >
          ACCOUNT PAGES
        </h6>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Profile'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/signin"
          :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="isRTL ? 'تسجيل الدخول' : 'Sign In'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/signup"
          :class="getRoute() === 'signup' ? 'active' : ''"
          :navText="isRTL ? 'اشتراك' : 'Sign Up'"
        >
          <template v-slot:icon>
            <i class="ni ni-collection text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li> -->
    </ul>
  </div>

  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card :card="{
      title: 'Need Help?',
      description: 'Please check our docs',
      links: [
        {
          label: 'Documentation',
          route:
            'https://www.creative-tim.com/learning-lab/vue/overview/argon-dashboard/',
          color: 'dark',
        },
        {
          label: 'Buy now',
          route:
            'https://www.creative-tim.com/product/vue-argon-dashboard-pro?ref=vadp',
          color: 'success',
        },
      ],
    }" />
  </div>
</template>
